/**
 * Utilidades cliente para leer/escribir la cookie NEXT_LOCALE.
 *
 * next-intl la lee server-side en cada RSC render; el cambio en el cliente
 * requiere reload (o router.refresh()) para que los componentes server
 * cojan el nuevo catálogo.
 */
import {
  DEFAULT_LOCALE,
  LOCALE_COOKIE,
  Locale,
  isSupportedLocale,
  normalizeLocale,
} from "@/i18n/config";

const ONE_YEAR = 60 * 60 * 24 * 365;

/** Lee el locale de la cookie NEXT_LOCALE del navegador. Devuelve default si no hay. */
export function readLocaleFromCookie(): Locale {
  if (typeof document === "undefined") return DEFAULT_LOCALE;
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${LOCALE_COOKIE}=([^;]+)`),
  );
  if (!match) return DEFAULT_LOCALE;
  const parsed = normalizeLocale(decodeURIComponent(match[1]));
  return parsed ?? DEFAULT_LOCALE;
}

/** Escribe la cookie NEXT_LOCALE (año de vida, path=/). No fuerza reload. */
export function writeLocaleCookie(locale: Locale): void {
  if (typeof document === "undefined") return;
  if (!isSupportedLocale(locale)) return;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie =
    `${LOCALE_COOKIE}=${locale}; path=/; max-age=${ONE_YEAR}; SameSite=Lax${secure}`;
}
